import { render, staticRenderFns } from "./StocktakingAdjust.vue?vue&type=template&id=32eeb4f2&scoped=true&"
import script from "./StocktakingAdjust.vue?vue&type=script&lang=js&"
export * from "./StocktakingAdjust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32eeb4f2",
  null
  
)

export default component.exports